import { render } from "./SimUserLimitMessage.vue?vue&type=template&id=dda40744&scoped=true"
import script from "./SimUserLimitMessage.vue?vue&type=script&lang=js"
export * from "./SimUserLimitMessage.vue?vue&type=script&lang=js"

import "./SimUserLimitMessage.vue?vue&type=style&index=0&id=dda40744&scoped=true&lang=scss"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dda40744"]])

export default __exports__